// Mock data for SmartDream clone

export const user = {
  name: "Niccolò",
  firstName: "Niccolò",
  lastName: "Magni",
  gender: "MASCHIO",
  birthDate: "12/12/1999",
  height: "178",
  weight: "72",
  email: "niccolo@smartdream.it",
  avatar: null,
  memberSince: "Gennaio 2025",
  device: "SmartDream Mattress Pro",
  serial: "SD-2024-88271",
  mattresses: [
    { id: "e86beacc434c", label: "Room 614 lato destro da piedi" },
    { id: "e86beacc44ac", label: "Room 613 lato sinistro da piedi" },
    { id: "e86beacc42b4", label: "Room 614 lato sinistro da piedi" },
    { id: "e86beacc4330", label: "Room 613 lato destro da piedi" },
    { id: "e86beacc443c", label: "Nuovo molle lato sinistro da piedi" },
    { id: "e86beacc43b4", label: "Nuovo molle lato destro da piedi" },
  ],
};

// Generate realistic time-series for a day (one sample every 15 min)
function genSeries({ base, variance, drift = 0, points = 96, decimals = 0 }) {
  const data = [];
  let last = base;
  for (let i = 0; i < points; i++) {
    const t = i / points;
    const noise = (Math.random() - 0.5) * variance;
    const d = Math.sin(t * Math.PI * 2) * drift;
    last = base + d + noise;
    data.push({
      t: i,
      time: `${String(Math.floor((i * 15) / 60)).padStart(2, "0")}:${String((i * 15) % 60).padStart(2, "0")}`,
      value: Number(last.toFixed(decimals)),
    });
  }
  return data;
}

export const todayData = {
  heartRate: genSeries({ base: 62, variance: 6, drift: 4, decimals: 0 }),
  breathRate: genSeries({ base: 14, variance: 2, drift: 2, decimals: 0 }),
  mattressTemp: genSeries({ base: 29, variance: 1.2, drift: 1.5, decimals: 1 }),
  mattressHumidity: genSeries({ base: 45, variance: 3, drift: 4, decimals: 0 }),
  roomTemp: genSeries({ base: 21.5, variance: 1, drift: 0.8, decimals: 1 }),
  roomHumidity: genSeries({ base: 52, variance: 4, drift: 3, decimals: 0 }),
};

export const sevenDays = {
  heartRate: Array.from({ length: 7 }, (_, i) => ({
    t: i,
    label: ["Lun", "Mar", "Mer", "Gio", "Ven", "Sab", "Dom"][i],
    value: 60 + Math.round(Math.random() * 10),
  })),
  breathRate: Array.from({ length: 7 }, (_, i) => ({
    t: i,
    label: ["Lun", "Mar", "Mer", "Gio", "Ven", "Sab", "Dom"][i],
    value: 13 + Math.round(Math.random() * 4),
  })),
  mattressTemp: Array.from({ length: 7 }, (_, i) => ({
    t: i,
    label: ["Lun", "Mar", "Mer", "Gio", "Ven", "Sab", "Dom"][i],
    value: Number((28 + Math.random() * 2).toFixed(1)),
  })),
  mattressHumidity: Array.from({ length: 7 }, (_, i) => ({
    t: i,
    label: ["Lun", "Mar", "Mer", "Gio", "Ven", "Sab", "Dom"][i],
    value: 42 + Math.round(Math.random() * 8),
  })),
  roomTemp: Array.from({ length: 7 }, (_, i) => ({
    t: i,
    label: ["Lun", "Mar", "Mer", "Gio", "Ven", "Sab", "Dom"][i],
    value: Number((20.5 + Math.random() * 2).toFixed(1)),
  })),
  roomHumidity: Array.from({ length: 7 }, (_, i) => ({
    t: i,
    label: ["Lun", "Mar", "Mer", "Gio", "Ven", "Sab", "Dom"][i],
    value: 48 + Math.round(Math.random() * 10),
  })),
};

export const thirtyDays = {
  heartRate: Array.from({ length: 30 }, (_, i) => ({
    t: i,
    label: `${i + 1}`,
    value: 58 + Math.round(Math.random() * 12),
  })),
  breathRate: Array.from({ length: 30 }, (_, i) => ({
    t: i,
    label: `${i + 1}`,
    value: 12 + Math.round(Math.random() * 5),
  })),
  mattressTemp: Array.from({ length: 30 }, (_, i) => ({
    t: i,
    label: `${i + 1}`,
    value: Number((27 + Math.random() * 3).toFixed(1)),
  })),
  mattressHumidity: Array.from({ length: 30 }, (_, i) => ({
    t: i,
    label: `${i + 1}`,
    value: 40 + Math.round(Math.random() * 12),
  })),
  roomTemp: Array.from({ length: 30 }, (_, i) => ({
    t: i,
    label: `${i + 1}`,
    value: Number((20 + Math.random() * 3).toFixed(1)),
  })),
  roomHumidity: Array.from({ length: 30 }, (_, i) => ({
    t: i,
    label: `${i + 1}`,
    value: 45 + Math.round(Math.random() * 15),
  })),
};

export const sensors = [
  {
    id: "heartRate",
    title: "BPM",
    subtitle: "Frequenza cardiaca",
    unit: "bpm",
    icon: "heart",
    current: 64,
    min: 58,
    max: 72,
    avg: 64,
    status: "Ottimo",
    yRange: [40, 100],
    info: "La frequenza cardiaca a riposo indica quanto efficientemente il cuore pompa sangue. Valori normali notturni sono tra 50 e 70 bpm.",
  },
  {
    id: "breathRate",
    title: "ATTI/m",
    subtitle: "Frequenza respiratoria",
    unit: "atti/min",
    icon: "nose",
    current: 15,
    min: 12,
    max: 18,
    avg: 14,
    status: "Regolare",
    yRange: [8, 24],
    info: "La frequenza respiratoria normale durante il sonno è tra 12 e 20 atti al minuto.",
  },
  {
    id: "mattressTemp",
    title: "°C",
    subtitle: "Temperatura del materasso",
    unit: "°C",
    icon: "thermometer",
    current: 29.2,
    min: 27.5,
    max: 30.8,
    avg: 28.9,
    status: "Ideale",
    yRange: [10, 40],
    info: "La temperatura del materasso influenza la qualità del sonno. Il range ideale è tra 28 e 32 °C.",
  },
  {
    id: "mattressHumidity",
    title: "%",
    subtitle: "Umidità del materasso",
    unit: "%",
    icon: "droplets",
    current: 46,
    min: 42,
    max: 51,
    avg: 46,
    status: "Ottimale",
    yRange: [0, 100],
    info: "L'umidità del materasso dovrebbe essere mantenuta tra il 40% e il 55% per un comfort ottimale.",
  },
  {
    id: "roomTemp",
    title: "°C",
    subtitle: "Temperatura stanza",
    unit: "°C",
    icon: "home-thermometer",
    current: 21.6,
    min: 20.1,
    max: 22.8,
    avg: 21.3,
    status: "Confortevole",
    yRange: [10, 40],
    info: "La temperatura ideale della camera da letto è tra i 18 e i 22 °C per favorire un sonno profondo.",
  },
  {
    id: "roomHumidity",
    title: "%",
    subtitle: "Umidità stanza",
    unit: "%",
    icon: "home-droplets",
    current: 54,
    min: 49,
    max: 60,
    avg: 53,
    status: "Buona",
    yRange: [0, 100],
    info: "L'umidità della stanza dovrebbe rimanere tra il 40% e il 60% per un ambiente salubre.",
  },
];

export const sleepSummary = {
  duration: "7h 42m",
  quality: 87,
  deep: "2h 15m",
  light: "4h 02m",
  rem: "1h 25m",
  awake: "0h 18m",
  score: 87,
  bedtime: "23:14",
  wakeup: "06:56",
};

// Phase levels: 0 = deep, 1 = light, 2 = rem, 3 = awake
export const sleepPhasesSeries = (() => {
  const points = [];
  // Generate a realistic series from 00:30 to 09:35 with 220 samples
  const total = 220;
  for (let i = 0; i < total; i++) {
    const t = i / (total - 1);
    // base sinusoidal with noise to simulate cycles of ~90min
    const cycle = Math.sin(t * Math.PI * 5) * 1.1;
    const phaseBias = -0.4 + t * 0.8; // drift toward lighter sleep late
    let v = 1.2 + cycle * 0.9 + phaseBias + (Math.random() - 0.5) * 0.5;
    // occasional awake spikes
    if (Math.random() < 0.03) v = 3 + Math.random() * 0.2;
    v = Math.max(0, Math.min(3.2, v));
    points.push(v);
  }
  return points;
})();

export const sleepSoundEvents = [
  { id: "e1", type: "cough", label: "Tosse", at: "01:33", duration: 4, count: 10, has_clip: true, clip_id: "mock_clip_1" },
  { id: "e2", type: "snore", label: "Russare", at: "02:48", duration: 12, count: 4, intensity: "alto", duration_sec: 200, has_clip: true, clip_id: "mock_clip_2" },
  { id: "e3", type: "talk", label: "Parlato", at: "03:47", duration: 3, count: 2, duration_sec: 12, has_clip: true, clip_id: "mock_clip_3" },
  { id: "e4", type: "move", label: "Movimento", at: "05:12", duration: 5, count: 1 },
  { id: "e5", type: "cough", label: "Tosse", at: "06:08", duration: 2, count: 10 },
  { id: "e6", type: "snore", label: "Russare", at: "07:34", duration: 9, count: 4 },
];

export const sleepDayStats = {
  date: "Sabato 18-19 apr",
  quality: 84,
  scoreMattress: 71,
  scoreIntegrated: 84,
  inBed: "9h 05m",
  asleep: "8h 07m",
  regularity: 76,
  fellAsleepIn: "15 min",
  bedtime: "00:30",
  wakeup: "09:35",
  snoring: "2 min",
  clips: { done: 0, total: 10 },
  mood: "OK",
  heartRateAvg: 65,
  coughPerHour: 0.4,
  coughLabel: "NORMALE",
  breathInterruptionsPerHour: 0.7,
  breathInterruptionsLabel: "BASSO",
};

// Week overview with quality rings
export const weekOverview = [
  { d: "L", label: "Lun", quality: 72 },
  { d: "M", label: "Mar", quality: 64 },
  { d: "M", label: "Mer", quality: 81 },
  { d: "G", label: "Gio", quality: 77 },
  { d: "V", label: "Ven", quality: 58 },
  { d: "S", label: "Sab", quality: 84, active: true },
  { d: "D", label: "Dom", quality: 0 },
];

export const sleepAidTracks = [
  { id: "rain", name: "Pioggia leggera", duration: "30:00" },
  { id: "ocean", name: "Onde del mare", duration: "45:00" },
  { id: "forest", name: "Bosco di notte", duration: "30:00" },
  { id: "fireplace", name: "Camino acceso", duration: "60:00" },
  { id: "whitenoise", name: "Rumore bianco", duration: "∞" },
];

// Ambient noise level over the night (dB)
export const ambientNoiseSeries = (() => {
  const N = 130;
  const arr = [];
  for (let i = 0; i < N; i++) {
    const t = i / (N - 1);
    const base = 22 + Math.sin(t * Math.PI * 3) * 4;
    const spikeChance = Math.random();
    let v = base + (Math.random() - 0.5) * 4;
    if (spikeChance < 0.04) v += 10 + Math.random() * 15;
    if (spikeChance < 0.008) v += 20;
    v = Math.max(8, Math.min(55, v));
    arr.push(Number(v.toFixed(1)));
  }
  return arr;
})();

export const ambientNoise = {
  median: 22.9,
  label: "BASSO",
  unit: "dB",
};

export const breathFrequency = {
  median: 12.2,
  label: "NORMALE",
  unit: "/min",
};

// Stats (7 days) for the Statistiche page
export const statsWeek = {
  quality: [
    { day: "lun", date: "13/04", value: 75 },
    { day: "mar", date: "14/04", value: 75 },
    { day: "mer", date: "15/04", value: 78 },
    { day: "gio", date: "16/04", value: 70 },
    { day: "ven", date: "17/04", value: 12 },
    { day: "ven", date: "17/04", value: 70 },
    { day: "sab", date: "18/04", value: 75 },
  ],
  regularity: [
    { day: "lun", date: "13/04", bed: "23:40", wake: "06:55", quality: 80 },
    { day: "mar", date: "14/04", bed: "23:55", wake: "07:05", quality: 80 },
    { day: "mer", date: "15/04", bed: "23:20", wake: "06:30", quality: 85 },
    { day: "gio", date: "16/04", bed: "00:05", wake: "07:15", quality: 88 },
    { day: "ven", date: "17/04", bed: "00:15", wake: "00:50", quality: 75 },
    { day: "ven", date: "17/04", bed: "01:20", wake: "08:40", quality: 76 },
    { day: "sab", date: "18/04", bed: "00:30", wake: "09:35", quality: 76 },
  ],
  bedtime: [
    { day: "lun", date: "13/04", value: "23:40" },
    { day: "mar", date: "14/04", value: "23:55" },
    { day: "mer", date: "15/04", value: "23:20" },
    { day: "gio", date: "16/04", value: "00:05" },
    { day: "ven", date: "17/04", value: "00:15" },
    { day: "ven", date: "17/04", value: "01:20" },
    { day: "sab", date: "18/04", value: "00:30" },
  ],
  wakeup: [
    { day: "lun", date: "13/04", value: "06:55" },
    { day: "mar", date: "14/04", value: "07:05" },
    { day: "mer", date: "15/04", value: "06:30" },
    { day: "gio", date: "16/04", value: "07:15" },
    { day: "ven", date: "17/04", value: "00:50" },
    { day: "ven", date: "17/04", value: "08:40" },
    { day: "sab", date: "18/04", value: "09:35" },
  ],
};
